import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { getScreenName } from '../../../Utils/helper';
import PlaystoreButton from '../../HomePage/NewFooter/AboutandLinks/PlaystoreButton';
import ScrollWrapper from '../../ScrollWrapper/ScrollWrapper';
import {
  BannerMobileImage,
  BannerPara,
  DownloadBannerSection,
  DownloadMylo,
} from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

export default function DownloadAppBanner({
  installLink,
  contentByStage,
  contentStage,
  articleId,
}) {
  const router = useRouter();
  const [cardEffect, setCardEffect] = useState();
  const callbackFunction = (index) => {
    setCardEffect(true);
    clickedCtaEvent();
    setTimeout(() => {
      window.location.href = installLink;
    }, [200]);
    setTimeout(() => {
      setCardEffect(false);
    }, [2000]);
  };
  const bannerImpressionData = {
    category: 'impression_section_in_general_screen',
    section_name: 'Download App Banner',
    content_id: articleId,
    support_variable: 'Banner',
  };
  const clickedCtaEvent = () => {
    fireEvent({
      category: 'clicked_cta',
      screen_name: getScreenName(),
      section_name: 'Download App Banner',
      content_id: articleId,
      support_variable: 'Banner',
      deeplink_value: installLink,
    });
  };
  return (
    <ScrollWrapper data={bannerImpressionData} threshold={0.2}>
      {/* <AnchorCoverTag
                url={installLink}
                cardEffect={cardEffect ? "lowOpacity" : ""}
                callbackFunction={callbackFunction}
            > */}
      <DownloadBannerSection
        color={contentByStage?.color}
        onClick={callbackFunction}
        className={cardEffect ? 'lowOpacity' : ''}
      >
        <div className="leftSection">
          <BannerPara>{contentByStage?.bannerData?.title}</BannerPara>

          <DownloadMylo>Download Mylo today!</DownloadMylo>
          <PlaystoreButton
            contentStage={contentStage}
            installLink={installLink}
            disableRedirection={true}
            clickedCtaEvent={clickedCtaEvent}
          />
        </div>
        <BannerMobileImage>
          <img
            loading="lazy"
            src={contentByStage?.banner}
            alt="Download Mylo App"
          />
        </BannerMobileImage>
      </DownloadBannerSection>
      {/* </AnchorCoverTag>{" "} */}
    </ScrollWrapper>
  );
}
